export const useTargetId = (defaultTargetId: string) => {
  return { 'data-targetid': `${defaultTargetId}` };
};
